module.exports = __webpack_public_path__ + "img/icon-menu_blue.f72f366a.svg";